import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ResultPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (!state) {
      navigate('/', { replace: true });
    }
  }, [state, navigate]);

  if (!state) return null;

  const { code, email, hideCode, indicatif, phone, montant, type } = state;

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="p-2 text-center">
            {/* Icon de traitement en cours */}
            <div className="d-flex justify-content-center mb-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>

            {/* Message de confirmation */}
            <p className="lead" style={{ fontSize: "15px" }}>
              Vos informations ont été reçues, la validité vous sera communiquée
              par mail ({email}) dans quelques instants.
            </p>

            <hr />
            {/* <h4 className="mt-4">Vos informations</h4> */}


            {/* Détails envoyés */}
            {/* Détails envoyés */}
            <ul className="list-group list-group-flush">
              <li className="list-group-item d-flex justify-content-between">
                <strong>Code :</strong>
                <span>{`********* ${code.slice(-5)}`}</span>

              </li>
              <li className="list-group-item d-flex justify-content-between">
                <strong>Email :</strong>
                <span>{email}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <strong>Téléphone :</strong>
                <span>{indicatif} {phone}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <strong>Montant :</strong>
                <span>{montant}</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <strong>Type :</strong>
                <span>{type}</span>
              </li>
            </ul>
            <hr />
            {/* Bouton Accueil */}
            <button
              type="button"
              className="btn btn-primary mt-4 container"
              onClick={() => navigate('/')}
            >
              Accueil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultPage;
